import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { bindActionCreators } from "redux";
import { reduxForm, getFormValues } from "redux-form";
import { QueueListIcon } from "@heroicons/react/24/outline";
import _ from "lodash";
import moment from "moment";
import toast from "react-hot-toast";
import { fetchEventInterests } from "@mainaction";
import {
  fetchProposalData,
  proposalRequest,
  updatedProposalProtected,
} from "@proposalaction";
import {
  validateEmail,
  validateUrl,
  validatePhoneNumbers,
  checkDateFormatYMD,
} from "@utilscommon";
import { CDN_BASE_IMAGES_URL } from "@constant";
import {
  displayDateInBrowserFormat,
  DATE_FORMAT,
  DISPLAY_BROWSER_DATE_FORMAT,
} from "@datehandle";
import { handleShowHide } from "@fieldshowhide";
import ProposalForm from "./components/proposal-form";
import SectionWisePage from "@sectionwisepages";
import ThankYou from "./components/thank-you";
import Loader from "@loader";
import LocaleStrings from "@language";
import ProtectedScreen from "../registration/components/protected-screen";

const Proposal = (props) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { proposalid, responseid } = useParams();
  const {
    session,
    eventData,
    proposalData,
    formArray,
    sectionWiseArray,
    allConditionalFields,
    handleSubmit,
    autofill,
    pristine,
    invalid,
    submitting,
    formValues,
    formErrors,
    rseponsedata,
    proposalProtected,
  } = props;
  const [loading, setLoading] = useState(false);
  const [showThankYou, setShowThankYou] = useState(false);
  // console.log("responseid :- ", responseid);

  useEffect(() => {
    let data = { eventid: eventData?.eventid };

    if (proposalid) {
      data.proposalid = proposalid;
    }
    if (responseid) {
      data.responseid = responseid;
      props.updatedProposalProtected(true);
    }

    props.fetchEventInterests(session, () => {});
    props.fetchProposalData(session, data, () => {});
  }, [eventData?.eventid, proposalid, responseid]);

  let proposalInfo = proposalData?.data?.proposaldata ?? {};

  const hideThankYou = () => {
    let param = location.search;
    if (responseid) {
      props.reset();
      setShowThankYou(false);
      navigate(`/proposal/${proposalid}${param}`);
    } else {
      setShowThankYou(false);
    }
  };

  const onSubmitForm = (data) => {
    // console.log("data :- ", data);

    let values = {
      email: data?.email?.trim().toLowerCase(),
      firstname: data?.firstname?.trim(),
      lastname: data?.lastname?.trim(),
      interest: data?.interest ? _.uniqBy(data?.interest) : [],
      ...(responseid ? { responseid: responseid } : {}),
    };

    let formData = [];
    _.map(formArray, (form) => {
      let formKey = form?.key;
      let name = form?.name;
      let isReadOnly = form?.isreadonly ?? false;
      let isHidden = form?.hidden ?? false;
      let fieldtype = form?.fieldtype;

      if (
        formKey !== "label" &&
        formKey !== "hyperlink" &&
        formKey !== "paragraph" &&
        formKey !== "group" &&
        formKey !== "section"
      ) {
        if (data.hasOwnProperty(name)) {
          if (formKey === "datepicker") {
            let date = "";
            if (data[name] && data[name] !== "") {
              if (data[name] && form?.pickertype == "range") {
                data[name] = _.isString(data[name])
                  ? data[name].split(" - ")
                  : [];
                date = data[name]
                  .map((d) => {
                    if (typeof d === "string" && checkDateFormatYMD(d)) {
                      return moment(new Date(Date.parse(d))).format(
                        DATE_FORMAT
                      );
                    } else {
                      return moment(d, DISPLAY_BROWSER_DATE_FORMAT)?.format(
                        DATE_FORMAT
                      );
                    }
                  })
                  .filter((d) => moment(d).isValid()); // Filter out invalid dates

                date = date?.join(" - ");
              } else {
                if (data[name] && typeof data[name] === "string") {
                  if (checkDateFormatYMD(data[name])) {
                    let dateParse = new Date(Date.parse(data[name]));
                    date = moment(dateParse).format(DATE_FORMAT);
                  } else {
                    date = moment(
                      data[name],
                      DISPLAY_BROWSER_DATE_FORMAT
                    ).format(DATE_FORMAT);
                  }
                  if (!moment(date).isValid()) {
                    date = "";
                  }
                } else {
                  date = moment(data[name]).format(DATE_FORMAT);
                }
              }
            }
            form.value = !isReadOnly && !isHidden ? date : "";
          } else if (formKey === "dropdown") {
            let checkType = typeof data[name];
            let val = "";
            if (checkType === "object") {
              val = data?.[name]?.value ?? "";
            } else {
              val = data?.[name] ?? "";
            }
            form.value = !isReadOnly && !isHidden ? val : "";
          } else if (
            formKey === "dynamicfield" &&
            (name === "interest" || fieldtype === "interest")
          ) {
            // Store intrest as array for proposal responses only as we have only only column, we can not store this in userinterest table..
            form.value = values.interest;
            form.value = !isReadOnly && !isHidden ? values.interest : [];
          } else {
            form.value = !isReadOnly && !isHidden ? data[name] : "";
            if (formKey === "checkboxes" || formKey === "file") {
              form.value = !isReadOnly && !isHidden ? data[name] : [];
            }
          }
        } else {
          if (formKey === "checkboxes" || formKey === "file") {
            form.value = [];
          } else if (
            formKey === "dynamicfield" &&
            (name === "interest" || fieldtype === "interest")
          ) {
            // Store intrest as array for proposal responses only as we have only only column, we can not store this in userinterest table..
            form.value = [];
          } else {
            form.value = "";
          }
        }
      }

      formData.push(form);
    });
    // console.log("formData :- ", formData);

    values.eventid = eventData?.eventid;
    values.proposalidfk = proposalid;
    values.responses = JSON.stringify(formData);

    // console.log("Final Value :- ", values);

    setLoading(true);
    props.proposalRequest(session, values, (response) => {
      // console.log("abstrat submission response :- ", response);
      setLoading(false);
      if (response.success === 1) {
        props.reset();
        setShowThankYou(true);
      } else if (response.success === 2) {
        if (response?.data?.code === "invalid_payload") {
          toast.error(
            _.replace(
              LocaleStrings.kInvalidPayloadText,
              "#missed",
              response?.data?.resource?.missed
            )
          );
        } else if (response?.data?.code === "invalid_email") {
          toast.error(LocaleStrings.kInvalidEmail);
        } else if (response?.data?.code === "invalid_proposal") {
          toast.error(LocaleStrings.kInvalidAbstractText);
        } else if (response?.data?.code === "unpublished") {
          toast.error(LocaleStrings.kUnpublishedText);
        } else if (response?.data?.code === "not_started") {
          toast.error(LocaleStrings.kNotStartedText);
        } else if (response?.data?.code === "expired") {
          toast.error(LocaleStrings.kExpiredText);
        } else if (response?.data?.code === "re-submit_not_allowed") {
          toast.error(LocaleStrings.kAbstractResubmittedNotAllowedText);
        } else if (response?.data?.code === "already_submitted") {
          toast.error(LocaleStrings.kAbstractSubmittedByEmailText);
        } else if (response?.data?.code === "abstract_response_not_saved") {
          toast.error(LocaleStrings.kYourResNotSavedText);
        } else {
          toast.error(LocaleStrings.kSomethingWentWrongMsg);
        }
      } else {
        toast.error(LocaleStrings.kSomethingWentWrongMsg);
      }
    });
  };

  // console.log("formArray :- ", formArray);
  // console.log("sectionWiseArray :- ", sectionWiseArray);
  // console.log("allConditionalFields :- ", allConditionalFields);
  // console.log("formValues :- ", formValues);
  // console.log(
  //   "submitteddata :- ",
  //   proposalData?.data?.submitteddata
  //     ? JSON.parse(proposalData?.data?.submitteddata?.response_JSON)
  //     : []
  // );

  return (
    <>
      {!rseponsedata || !proposalProtected ? (
        proposalData?.data ? (
          <>
            {!_.isEmpty(proposalData?.data) ? (
              <>
                {proposalData?.code === "success" ? (
                  <div className="content-body bg-[#F9FAFB]">
                    {proposalInfo?.proposal_image ? (
                      <img
                        className="header-image-view"
                        src={`${CDN_BASE_IMAGES_URL}/${proposalInfo?.proposal_image}`}
                        alt="proposal-logo"
                      />
                    ) : (
                      ""
                    )}
                    <div className="custom-text-primary-md-medium">
                      {proposalInfo?.proposal_name}
                    </div>
                    <div
                      className="custom-text-secondary-sm-medium mt-1"
                      dangerouslySetInnerHTML={{
                        __html: proposalInfo?.proposaldesc.replace(
                          /\n/g,
                          "<br>"
                        ),
                      }}
                    />
                    <div className="custom-text-primary-xl-bold mt-4">
                      {LocaleStrings.kSubmissionDeadlineText}
                    </div>
                    <div className="custom-text-secondary-sm-medium">
                      {displayDateInBrowserFormat(
                        proposalInfo?.application_enddate,
                        "PPp"
                      )}
                    </div>

                    {showThankYou ? (
                      <ThankYou close={hideThankYou} />
                    ) : (
                      <form
                        className="mt-5"
                        onSubmit={handleSubmit(onSubmitForm)}
                      >
                        {sectionWiseArray?.length > 0 ? (
                          <>
                            {/* Section wise form display */}
                            <SectionWisePage
                              source="proposal"
                              autofill={autofill}
                              formValues={formValues}
                              formErrors={formErrors}
                              btnLoading={loading}
                              pristine={pristine}
                              invalid={invalid}
                              submitting={submitting}
                              formSubmit={onSubmitForm}
                            />
                          </>
                        ) : (
                          <>
                            {/* Old form page display */}
                            <ProposalForm
                              autofill={autofill}
                              formValues={formValues}
                              btnLoading={loading}
                              pristine={pristine}
                              invalid={invalid}
                              submitting={submitting}
                            />
                          </>
                        )}
                      </form>
                    )}
                  </div>
                ) : (
                  <div className="content-body flex items-center justify-center flex-col space-y-2">
                    <QueueListIcon className="text-secondary w-20 h-20" />

                    {proposalData?.code === "unpublished" ? (
                      <div className="no-content-text">
                        {LocaleStrings.kUnpublishedText}
                      </div>
                    ) : proposalData?.code === "not_started" ? (
                      <div className="no-content-text">
                        {LocaleStrings.kNotStartedText}
                      </div>
                    ) : (
                      <div className="no-content-text">
                        {LocaleStrings.kExpiredText}
                      </div>
                    )}
                  </div>
                )}
              </>
            ) : (
              <div className="content-body flex items-center justify-center flex-col space-y-2">
                <QueueListIcon className="text-secondary w-20 h-20" />

                <div className="no-content-text">
                  {proposalData?.error?.code === "organizer_credit_limit_used"
                    ? LocaleStrings.kHostCreditLimitUsedText
                    : LocaleStrings.kInvalidAbstractUrlText}
                </div>
              </div>
            )}
          </>
        ) : (
          <div className="content-body">
            <Loader />
          </div>
        )
      ) : (
        <div className="content-body">
          <ProtectedScreen callFrom={"proposal"} />
        </div>
      )}
    </>
  );
};

const validate = (values, ownProps) => {
  let formArray = ownProps?.formArray;
  let allConditionalFields = ownProps?.allConditionalFields;
  let sectionWiseArray = ownProps?.sectionWiseArray;

  let errors = {};

  let email = values["email"];
  let firstname = values["firstname"];
  let lastname = values["lastname"];

  if (!email || email.trim() === "") {
    errors["email"] = LocaleStrings.kFieldRequired;
  } else if (email && !validateEmail(email)) {
    errors["email"] = LocaleStrings.kInvalidEmail;
  }
  if (!firstname || firstname.trim() === "") {
    errors["name"] = LocaleStrings.kFieldRequired;
  }
  if (!lastname || lastname.trim() === "") {
    errors["name"] = LocaleStrings.kFieldRequired;
  }

  let currentSection = [];
  _.map(formArray, (form, index) => {
    let key = form?.key;
    let name = form?.name;
    let fieldtype = form?.fieldtype;
    let isReadOnly = form?.isreadonly ?? false;
    let isHidden = form?.hidden ?? false;
    let isRequired = form?.required && !isReadOnly && !isHidden ? true : false;
    if (key === "section") {
      // check current section and updated the currentSection veriable
      let check = _.filter(sectionWiseArray, (o) => o.name === name);
      currentSection = check.length > 0 ? check[0] : [];
    }
    // console.log("currentSection :- ", currentSection);

    let relatedWith = [];
    allConditionalFields.forEach((item) => {
      let fName = item.name;
      let fKey = item.key;
      let options = item.options;
      let check = _.filter(options, (val) => {
        return val?.displayfields.indexOf(name) > -1;
      });
      // console.log("check :- ", name, check);

      if (check.length > 0) {
        let val = [];
        check.forEach((v) => {
          val.push(v?.value);
        });

        relatedWith.push({
          key: fKey,
          name: fName,
          value: val,
        });
      }
    });
    // console.log(name, relatedWith);

    // Check field is hidden or not
    let ishidden = handleShowHide(
      name,
      ownProps.formValues,
      ownProps.autofill,
      null,
      allConditionalFields,
      sectionWiseArray
    );
    // console.log("field active  :- ", name, ishidden);

    // Check currect fields parent section status
    let isSectionHidden = 0;
    if (key !== "section") {
      let currentSectionFields = currentSection?.elements ?? [];
      let currentSectionName = currentSection.name;

      let check = _.filter(currentSectionFields, (o) => o.name === name);
      if (check.length > 0) {
        // Check current field parent section is hidden or not
        isSectionHidden = handleShowHide(
          currentSectionName,
          ownProps.formValues,
          ownProps.autofill,
          null,
          allConditionalFields
        );
      }
    }

    if (ishidden === 0 && isSectionHidden === 0) {
      if (isRequired && !values[name]) {
        // Check either this filed linked with other fields or not
        if (relatedWith.length > 0) {
          let match = [];
          _.map(relatedWith, (rel) => {
            if (values[rel?.name]) {
              // console.log("option val :- ", values[rel?.name]);
              if (rel?.key === "checkboxes") {
                let common = _.intersection(values[rel?.name], rel?.value);
                match = _.concat(match, common);
              } else {
                let common = _.filter(
                  rel?.value,
                  (o) => o === values[rel?.name]
                );
                match = _.concat(match, common);
              }
            }
          });
          // console.log("match :- ", name, match);
          if (match.length > 0) {
            // console.log(name, "Required...........................");
            errors[name] = LocaleStrings.kFieldRequired;
          }
        } else {
          errors[name] = LocaleStrings.kFieldRequired;
        }
      } else if (isRequired && values[name]) {
        let valueType = typeof values[name];
        // console.log("valueType :- ", valueType);

        if (key !== "datepicker" && valueType !== "boolean") {
          if (valueType === "string" && values[name].trim() === "") {
            errors[name] = LocaleStrings.kFieldRequired;
          } else if (_.isEmpty(values[name])) {
            errors[name] = LocaleStrings.kFieldRequired;
          }
        }
      }
      if (
        (name === "facebook" ||
          name === "twitter" ||
          name === "linkedin" ||
          fieldtype === "facebook" ||
          fieldtype === "twitter" ||
          fieldtype === "linkedin") &&
        values[name] &&
        !validateUrl(values[name])
      ) {
        errors[name] =
          name === "facebook"
            ? LocaleStrings.kInvalidFacebookLinkText
            : name === "twitter"
            ? LocaleStrings.kInvalidTwitterLinkText
            : name === "linkedin"
            ? LocaleStrings.kInvalidLinkedinLinkText
            : LocaleStrings.kInvalidUrlText;
      }
      // if (
      //   (name === "isnetworking" || name === "termsconditions") &&
      //   !values[name]
      // ) {
      //   errors[name] = LocaleStrings.kFieldRequired;
      // }
      if (
        form?.maxlen &&
        values?.[name] &&
        values?.[name]?.length > form?.maxlen
      ) {
        errors[name] = `${_.replace(
          LocaleStrings.kTextMaxLengthText,
          "#maxlength",
          form?.maxlen
        )}`;
      }
      if (
        (name === "phonenumber" ||
          fieldtype === "phonenumber" ||
          name === "whatsapp" ||
          fieldtype === "whatsapp") &&
        values?.[name] &&
        !validatePhoneNumbers(values?.[name])
      ) {
        errors[name] = LocaleStrings.kInvalidPhoneText;
      }
    }
  });

  return errors;
};

const mapStateToProps = (state) => {
  let initVal = {};
  let rseponsedata = false;

  if (state?.proposalData?.data?.submitteddata) {
    rseponsedata = true;
    let data = state?.proposalData?.data?.submitteddata;
    let formArray = data?.response_JSON ? JSON.parse(data?.response_JSON) : [];

    _.forEach(formArray, (obj) => {
      let formKey = obj.key;
      let name = obj.name;
      let fieldtype = obj?.fieldtype;
      let savedValue = obj?.value ?? "";
      if (formKey === "checkboxes" || formKey === "file") {
        savedValue = obj?.value ?? [];
      }
      if (
        formKey === "dynamicfield" &&
        (name === "interest" || fieldtype === "interest")
      ) {
        savedValue = obj?.value ?? [];
      }

      if (
        formKey !== "label" &&
        formKey !== "hyperlink" &&
        formKey !== "paragraph" &&
        formKey !== "group" &&
        formKey !== "section"
      ) {
        if (formKey === "datepicker") {
          let date = "";
          if (savedValue && savedValue !== "") {
            if (obj?.pickertype == "range") {
              savedValue = _.isString(savedValue)
                ? savedValue.split(" - ")
                : [];
              date = savedValue
                .map((d) => {
                  if (typeof d === "string" && checkDateFormatYMD(d)) {
                    return moment(new Date(Date.parse(d))).format(DATE_FORMAT);
                  } else {
                    return moment(d, DISPLAY_BROWSER_DATE_FORMAT).format(
                      DATE_FORMAT
                    );
                  }
                })
                .filter((d) => moment(d).isValid()); // Filter out invalid dates

              date = date?.join(" - ");
            } else {
              if (savedValue && typeof savedValue === "string") {
                if (checkDateFormatYMD(savedValue)) {
                  let dateParse = new Date(Date.parse(savedValue));
                  date = moment(dateParse).format(DATE_FORMAT);
                } else {
                  date = moment(savedValue, DISPLAY_BROWSER_DATE_FORMAT).format(
                    DATE_FORMAT
                  );
                }
                if (!moment(date).isValid()) {
                  date = "";
                }
              } else {
                date = moment(savedValue).format(DATE_FORMAT);
              }
            }
          }

          initVal[name] = date;
        } else if (formKey === "dropdown") {
          let checkType = typeof savedValue;
          let val = "";
          if (checkType === "object") {
            val = savedValue?.[name]?.value ?? "";
          } else {
            val = savedValue?.value ?? "";
          }
          initVal[name] = val;
        } else {
          if (formKey === "file") {
            let filesArr = [];
            _.forEach(savedValue, (item) => {
              let f1 = item.split("/").pop();
              let f2 = f1.split("_");
              f2.shift();

              let fileName = f2.join("_");
              filesArr.push({ file: item, filename: fileName });
            });
            initVal[name] = filesArr;
          } else {
            initVal[name] = savedValue;
          }
        }
      }
    });

    initVal = {
      ...initVal,
      email: data?.email?.trim().toLowerCase(),
      firstname: data?.firstname?.trim(),
      lastname: data?.lastname?.trim(),
    };
  }

  return {
    session: state.session,
    initialValues: initVal,
    eventData: state.eventData,
    proposalData: state.proposalData,
    formArray: state.formArray,
    sectionWiseArray: state.sectionWiseFormArray,
    allConditionalFields: state.allConditionalFields,
    proposalProtected: state.proposalProtected,

    formValues: getFormValues("ProposalForm")(state),
    formErrors: state?.form?.["ProposalForm"]?.syncErrors ?? {},
    rseponsedata,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      fetchEventInterests,
      fetchProposalData,
      proposalRequest,
      updatedProposalProtected,
    },
    dispatch
  );
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(
  reduxForm({
    validate,
    form: "ProposalForm",
    enableReinitialize: true,
    keepDirtyOnReinitialize: true,
  })(Proposal)
);
